class ProductMedia extends HTMLElement {
    // connect component
    connectedCallback() {
        const breakpoint = window.matchMedia("(max-width: 990px)");
        let productMediaSlider;
        let onClick;
        const checkBreakpoint = function () {
            const allSliders = document.querySelectorAll('.swiper-product-media');
            allSliders.forEach(slider => {
                if (slider.dataset.desktopLayout === "slider") {
                    enableSlider(slider);
                } else {
                    // display in stacked format on desktop
                    if (breakpoint.matches === false) {
                        disableSlider(slider);
                        // Scroll to initial image on page load for stacked layout
                        scrollToInitialImage(slider);
                    // display in slider format on mobile
                    } else if (breakpoint.matches === true) {
                        if (!slider.classList.contains("swiper-initialized")) {
                            enableSlider(slider);
                        }
                    }
                }
                if (breakpoint.matches === false) {
                    return enableZoom();
                // don't enable zoom on mobile.
                } else if (breakpoint.matches === true) {
                    return disableZoom();
                }
            });
        }
        const enableSlider = function (slider) {
            const sliderId = slider.id;
            slider.classList.remove("product-grid");
            let slideCount = slider.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)").length;
            const thumbsId = `${sliderId}--thumbs`;

            // Get initial slide from data attribute (set by Liquid based on selected variant)
            const initialSlide = parseInt(slider.dataset.initialSlide) || 0;

            let thumbsSwiper;
            if (document.getElementById(thumbsId)) {
                thumbsSwiper = new Swiper(`#${thumbsId}`, {
                    loop: false,
                    slidesPerView: 5,
                    spaceBetween: 5,
                    initialSlide: initialSlide
                });
            }
            if (slideCount > 1) {
                productMediaSlider = new Swiper(`#${sliderId}`, {
                    loop: false,
                    initialSlide: initialSlide,
                    zoom: {
                        maxRatio: 5,
                        containerClass: `swiper-zoom-container`
                    },
                    pagination: {
                        el: `#${sliderId} .swiper-pagination`,
                        clickable: true
                    },
                    navigation: {
                        nextEl: `#${sliderId} .swiper-button-next`,
                        prevEl: `#${sliderId} .swiper-button-prev`
                    },
                    thumbs: {
                        swiper: thumbsSwiper,
                    },
                });
            }
        }

        const disableSlider = function () {
            if (productMediaSlider !== undefined) {
                productMediaSlider.destroy(true, true);
            }
        }

        const scrollToInitialImage = function (slider) {
            // Only scroll on initial page load, not every time layout changes
            if (slider.dataset.initialScrollDone) return;
            slider.dataset.initialScrollDone = 'true';

            const initialSlide = parseInt(slider.dataset.initialSlide) || 0;
            if (initialSlide === 0) return; // Already at first image

            const slides = slider.querySelectorAll('.swiper-slide');
            if (slides[initialSlide]) {
                const targetSlide = slides[initialSlide];
                const stickyHeader = document.querySelector('sticky-header');
                const headerOffset = stickyHeader ? stickyHeader.offsetHeight : 0;

                const scrollPosition = targetSlide.getBoundingClientRect().top + window.pageYOffset - headerOffset;
                window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
            }
        }

        const enableZoom = function () {
            document.getElementById("MainProduct").classList.add("product-grid");
            let slides = document.getElementsByClassName("swiper-zoom-container");
            Array.from(slides).forEach((slide) => {
                const onMouseMove = function (event) {
                    const x = event.offsetX / slide.offsetWidth * 100
                    const y = event.offsetY / slide.offsetHeight * 100
                    slide.style.backgroundPosition = x + '% ' + y + '%';
                }
                // remove zoom
                const onMouseOut = function () {
                    slide.removeEventListener("mousemove", onMouseMove);
                    slide.removeEventListener("mouseout", onMouseOut);
                    slide.classList.remove("js-zoom-container");
                    slide.style.backgroundImage = "";
                }
                const onClick = function () {
                    let imageUrl = slide.children[0].src;
                    slide.style.backgroundImage = `url(${imageUrl})`;
                    slide.classList.add("js-zoom-container");
                    slide.addEventListener("mousemove", onMouseMove);
                    slide.addEventListener("mouseout", onMouseOut);
                }
                slide.addEventListener("click", onClick);
            });
        }

        const disableZoom = function () {
            let slides = document.getElementsByClassName("swiper-zoom-container");
            Array.from(slides).forEach((slide) => {
                slide.removeEventListener("click", onClick);
            });
        }

        breakpoint.addListener(checkBreakpoint);
        checkBreakpoint(); // first check
    }
}


customElements.define('product-media', ProductMedia);

(function () {
  function slug(v) {
    return String(v || "")
      .toLowerCase().trim()
      .replace(/ä/g,'ae').replace(/ö/g,'oe').replace(/ü/g,'ue').replace(/ß/g,'ss')
      .replace(/[^a-z0-9]+/g,'-')
      .replace(/^-+|-+$/g,'');
  }

 function getKey() {
  // 1) Theme Variant-Radios (Shopify Dawn/ähnlich)
  let el = document.querySelector('variant-radios input[type="radio"]:checked');
  if (el?.value) return slug(el.value);

  // 2) Alternative Radio-Gruppen (falls dein Theme ohne variant-radios arbeitet)
  el = document.querySelector('form[action^="/cart/add"] input[type="radio"]:checked');
  if (el?.value) return slug(el.value);

  // 3) Theme Variant-Selects
  el = document.querySelector('variant-selects select');
  if (el?.value) return slug(el.value);

  // 4) Fallback: irgendein Options-Select
  el = document.querySelector('select[name^="options["]');
  if (el?.value) return slug(el.value);

  return "";
}


  function snapshotOnce(el) {
    if (!el || el.dataset.snap === '1') return;
    const w = el.querySelector('.swiper-wrapper');
    if (!w) return;
    el._all = w.innerHTML;
    el.dataset.snap = '1';
  }

function restore(el) {
  const w = el?.querySelector('.swiper-wrapper');
  if (!w || !el._all) return;

  // HTML zurück
  w.innerHTML = el._all;

  // ✅ Swiper-Styles komplett resetten (sonst "merkt" er sich die alte Position)
  el.classList.remove('swiper-initialized');
  el.removeAttribute('style');
  w.removeAttribute('style');

  // slides reset
  el.querySelectorAll('.swiper-slide').forEach(s => {
    s.removeAttribute('style');
    s.classList.remove('swiper-slide-active','swiper-slide-next','swiper-slide-prev');
  });
}


  function hardFilter(el, key) {
    const w = el.querySelector('.swiper-wrapper');
    const slides = Array.from(w.querySelectorAll('.swiper-slide[data-set-key]'));
    slides.forEach(s => {
      const k = slug(s.dataset.setKey);
      if (k !== key && k !== 'all') s.remove();
    });
    return w.querySelectorAll('.swiper-slide').length;
  }

 function rebuild() {
  const key = getKey();
  if (!key) return;

  const mainEl = document.querySelector('.swiper-product-media');
  const thumbsEl = document.querySelector('.swiper-product-thumbnails');
  if (!mainEl) return;

  snapshotOnce(mainEl);
  if (thumbsEl) snapshotOnce(thumbsEl);

  // alte Instanzen killen
  if (thumbsEl?.swiper) thumbsEl.swiper.destroy(true, true);
  if (mainEl.swiper) mainEl.swiper.destroy(true, true);

  // HTML + Styles reset
  restore(mainEl);
  if (thumbsEl) restore(thumbsEl);

  // filtern (hart entfernen)
  const mainCount = hardFilter(mainEl, key);
  const thumbsCount = thumbsEl ? hardFilter(thumbsEl, key) : 0;
  if (mainCount <= 0) return;

  // thumbs neu
  let thumbsSwiper;
  if (thumbsEl && thumbsCount > 1) {
    thumbsSwiper = new Swiper(`#${thumbsEl.id}`, {
      loop: false,
      slidesPerView: 5,
      spaceBetween: 5,
      initialSlide: 0
    });
  }

  // main neu
  const mainSwiper = new Swiper(`#${mainEl.id}`, {
    loop: false,
    initialSlide: 0,
    zoom: { maxRatio: 5, containerClass: 'swiper-zoom-container' },
    pagination: { el: `#${mainEl.id} .swiper-pagination`, clickable: true },
    navigation: {
      nextEl: `#${mainEl.id} .swiper-button-next`,
      prevEl: `#${mainEl.id} .swiper-button-prev`,
    },
    thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
  });

  // ✅ nach Init auf Slide 0 festnageln (sonst springt er zurück)
  requestAnimationFrame(() => {
    try {
      if (thumbsSwiper) thumbsSwiper.slideTo(0, 0, false);
      mainSwiper.slideTo(0, 0, false);
      mainSwiper.update();
    } catch(e){}
  });
}


  // SUPER wichtig: Variant ID Input beobachten (Theme setzt Variante oft ohne "change")
  function watchVariantId() {
  const form = document.querySelector('form[action^="/cart/add"]');
  const idInput = form?.querySelector('input[name="id"]');
  if (!idInput) return;

  let last = idInput.value || "";

  // Poll fallback (Value-Änderung ist keine Mutation)
  setInterval(() => {
    const v = idInput.value || "";
    if (v !== last) {
      last = v;
      rebuild();
    }
  }, 200);

  // Optional: falls Theme "value" Attribut setzt
  const obs = new MutationObserver(() => {
    const v = idInput.getAttribute("value") || "";
    if (v && v !== last) {
      last = v;
      rebuild();
    }
  });
  obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });
}


  window.addEventListener('load', () => {
    rebuild();
    watchVariantId();
  });

  document.addEventListener('change', (e) => {
  if (!e.target) return;

  if (
    e.target.matches('variant-radios input[type="radio"]') ||
    e.target.matches('variant-selects select') ||
    e.target.matches('form[action^="/cart/add"] input[type="radio"]') ||
    e.target.matches('select[name^="options["]')
  ) {
    setTimeout(rebuild, 50);
  }
});

})();




